module.exports = __webpack_public_path__ + "img/pef_investment_overview_icon03.f5260e0d.svg";